import React from 'react';
import { CnLayoutHeader as UICnLayoutHeader } from '@cainiaofe/cn-ui';
const CnLayoutHeader = (props) => {
    const { children, title, desc, label, avatar } = props || {};
    const realLabel = label &&
        label.map((item) => {
            return item?.name;
        });
    return (<UICnLayoutHeader title={title} desc={desc} avatar={avatar} label={realLabel}>
      {children}
    </UICnLayoutHeader>);
};
CnLayoutHeader.displayName = 'CnLayoutHeader';
CnLayoutHeader.typeMark = 'Header';
export default CnLayoutHeader;
export { CnLayoutHeader };
